import React from "react";

/**
 * Non-intrusive AdSense placeholder slot.
 * Real ad code should replace the inner content once the site is approved.
 */
export default function AdSlot({ label = "Advertisement", className = "" }) {
  return (
    <div
      data-testid="ad-slot"
      className={`w-full bg-slate-50 dark:bg-[#121316] border border-dashed border-slate-300 dark:border-white/15 rounded-xl flex flex-col items-center justify-center text-slate-400 py-8 my-6 text-xs uppercase tracking-widest ${className}`}
    >
      <span>{label}</span>
      <span className="text-[10px] mt-1 text-slate-400 dark:text-slate-500">AdSense placeholder</span>
    </div>
  );
}
